import e from "./node_modules/.pnpm/colorjs.io@0.5.2/node_modules/colorjs.io/dist/color.js";
import { getTextColorBasedOnBgColor as u } from "./color-utils.js";
const d = "#000000", C = {
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.05)",
    100: "rgba(255, 255, 255, 0.1)",
    200: "rgba(255, 255, 255, 0.15)",
    300: "rgba(255, 255, 255, 0.2)",
    400: "rgba(255, 255, 255, 0.3)",
    500: "rgba(255, 255, 255, 0.4)",
    600: "rgba(255, 255, 255, 0.5)",
    700: "rgba(255, 255, 255, 0.6)",
    800: "rgba(255, 255, 255, 0.7)",
    900: "rgba(255, 255, 255, 0.8)",
    950: "rgba(255, 255, 255, 0.9)",
    1e3: "rgba(255, 255, 255, 0.95)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.05)",
    100: "rgba(0, 0, 0, 0.1)",
    200: "rgba(0, 0, 0, 0.15)",
    300: "rgba(0, 0, 0, 0.2)",
    400: "rgba(0, 0, 0, 0.3)",
    500: "rgba(0, 0, 0, 0.4)",
    600: "rgba(0, 0, 0, 0.5)",
    700: "rgba(0, 0, 0, 0.6)",
    800: "rgba(0, 0, 0, 0.7)",
    900: "rgba(0, 0, 0, 0.8)",
    950: "rgba(0, 0, 0, 0.9)",
    1e3: "rgba(0, 0, 0, 0.95)"
  },
  gray: {
    // tailwind modified gray scheme
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#eaecf1",
    // Slightly lightened
    300: "#d8dce2",
    // Slightly lightened
    400: "#c4c9d2",
    // New color (the rest of the colors are shifted accordingly)
    500: "#9ca3af",
    600: "#6b7280",
    700: "#4b5563",
    800: "#374151",
    900: "#1f2937",
    950: "#111827",
    1e3: "#030712"
  },
  // radix neutral gray for dark mode ('grayDark')
  grayDark: {
    1e3: "#111111",
    950: "#191919",
    900: "#222222",
    800: "#2a2a2a",
    700: "#313131",
    600: "#3a3a3a",
    500: "#484848",
    400: "#606060",
    300: "#6e6e6e",
    200: "#7b7b7b",
    100: "#b4b4b4",
    50: "#eeeeee"
  },
  overlay: {
    light: "rgba(104, 112, 118, 0.5)",
    dark: "rgba(136, 144, 150, 0.5)"
  }
};
function o(n) {
  return n.to("srgb").toString({ format: "hex" });
}
function g(n, r, t) {
  const c = n.lch, a = r.lch, s = c.l + (a.l - c.l) * t, b = c.c + (a.c - c.c) * t, h = c.h + (a.h - c.h) * t;
  return new e("lch", [s, b, h]);
}
function l(n) {
  return n.to("srgb");
}
const w = new e(d), m = (n) => {
  const r = n instanceof e ? n : new e(n), t = r.lch.c < 3 ? r.lch.c : 3, c = r.lch.c < 10 ? r.lch.c : 10, a = r.lch.c < 5 ? r.lch.c : 5;
  return {
    textBold: new e("lch", [10, a, r.lch.h]),
    textSubtle: new e("lch", [30, c, r.lch.h]),
    lighter: new e("lch", [98, r.lch.c * 1.2, r.lch.h * 0.96]),
    light: new e("lch", [89, r.lch.c * 1.2, r.lch.h * 0.96]),
    lightSubtle: new e("lch", [98, t, r.lch.h * 0.98]),
    medium: r,
    mediumSubtle: new e(
      "lch",
      [r.lch.l * 0.5, r.lch.c, r.lch.h],
      0.3
    ),
    strong: new e("lch", [r.lch.l * 0.85, r.lch.c, r.lch.h]),
    stronger: new e("lch", [r.lch.l * 0.5, r.lch.c, r.lch.h])
  };
}, f = m(w), x = (n, r) => {
  const t = Object.assign(
    {},
    r ? m(r) : f,
    n
  );
  for (const h of Object.keys(t))
    t[h] instanceof e || (t[h] = new e(t[h]));
  const c = Object.keys(t).reduce((h, i) => (h[i] = t[i].toGamut({ space: "srgb", method: "lch.c" }).to("srgb").toString({ format: "hex" }), h), {}), a = {
    50: o(l(t.lighter)),
    100: o(l(g(t.lighter, t.light, 0.5))),
    200: o(l(t.light)),
    300: o(l(g(t.light, t.medium, 0.5))),
    400: o(l(g(t.light, t.medium, 0.75))),
    500: o(l(t.medium)),
    600: o(l(g(t.medium, t.strong, 0.75))),
    700: o(l(t.strong)),
    800: o(l(g(t.strong, t.stronger, 0.5))),
    900: o(l(t.stronger)),
    950: o(l(g(t.stronger, t.textBold, 0.5))),
    1e3: o(
      l(g(t.stronger, t.textBold, 0.75))
    )
  }, s = c.textColorOnPrimary || u(
    c.medium,
    "#ffffff",
    c.textBold
  );
  return {
    inkeepPrimary: {
      ...c,
      textColorOnPrimary: s
    },
    inkeepExpandedPrimary: a
  };
}, S = x(f), B = {
  ...S,
  ...C
};
export {
  d as DEFAULT_PRIMARY_BRAND_COLOR,
  B as colors,
  m as createColorDict,
  x as createColorScheme
};
